var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoadArrows(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 13.3333H15.8333V17.5M8.33333 6.66667H4.16667V2.5M16.1813 7.50284C15.7141 6.34638 14.9318 5.3442 13.9233 4.61019C12.9149 3.87618 11.721 3.4396 10.4769 3.35042C9.23281 3.26125 7.98839 3.52284 6.88558 4.10551C5.78277 4.68819 4.86569 5.56878 4.23828 6.64677M3.81836 12.4976C4.2856 13.654 5.06788 14.6562 6.07631 15.3902C7.08474 16.1242 8.2799 16.5602 9.52398 16.6494C10.7681 16.7386 12.0115 16.477 13.1143 15.8944C14.2171 15.3117 15.1335 14.4313 15.7609 13.3533",
    stroke: "#89796E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadArrows);
export default __webpack_public_path__ + "static/media/loadArrows.b693aac5cf2a47c763450bd11d4046f1.svg";
export { ForwardRef as ReactComponent };